import React, { useState,useEffect } from 'react';

import axios from 'axios';
import { useParams,useHistory } from "react-router-dom";

import {Configs} from '../api';

const EditTodo =()=> {
    let history= useHistory();
    const id =useParams({})
  const [name, setname] = useState('')
  const [price, setprice] = useState('')
  
const [catLoc, setcatLoc] = useState('')
const [ExtrasAvail, setExtrasAvail] = useState(false)

const [barItems, setItems] = useState([])

  const adddata = async(e) =>{

    try {
    console.log(name,price,catLoc)
    const result = await axios.post(Configs.extras+'/'+id.id,
    {
      name : name,
      price : price,
      itemId :catLoc,
      extrasavailable : ExtrasAvail
  
    })
    console.log(result)
   history.push('/dashboard/extras')
    
  }
    catch (error) {
      console.log(error.message);
  }
  }


  useEffect(() => {
    const dataID = async() =>{

      try {
      const result = await axios.get(Configs.extras+'/'+id.id)
      // console.log(result.data.items)
      setname(result.data.extras.name)
      setprice(result.data.extras.price)
      // console.log(result.data.extras.extrasavailable)
      setExtrasAvail(result.data.extras.extrasavailable)
     
    }
      catch (error) {
        console.log(error.message);
    }
    }
    const loadLocations= async()=>{
      // console.log(catLoc)
      try {
        const result = await axios.get(Configs.items)
        // console.log(result.data.location)
        setItems(result.data.items)
      }
        catch (error) {
          console.log(error.message);
      }
      }
    
    

    dataID();
    loadLocations();
  },[id.id]);
  
  return ( 

<div className="container-fluid box-styl" >
<h1 className="text-center mt-5">Edit Extras</h1>
<form className="d-flex mt-5  mb-5 algnItm"  onSubmit={e=>{adddata(e)}}>
<input type='text' 
        className="form-control input-styl1"
          value={name}
          onChange={e=> setname(e.target.value)}
            required
        >
           </input>

           <input type='text' 
          className="form-control input-styl1"
          value={price}
          onChange={e=> setprice(e.target.value)}
            required
        >
           </input>

        <select id="dropdown" 
        value={barItems._id} 
        onChange={(e)=>setcatLoc(e.target.value)} 
        required
        className="form-control input-styl1"
        >
        
        <option value='' >select Items</option>
        {barItems.map((loc)=>(
          
       
          <option key={loc._id} value={loc._id}>{loc.name}</option>
        )
        )
        }
          
        </select>
        <div>
        <label style={{color: 'black'}} 
          > Extras Available</label>
        <input type="checkbox" checked={ExtrasAvail} 
          value={ExtrasAvail} 
          onChange={(e)=>setExtrasAvail(!ExtrasAvail)}></input>
            </div>
          <button className="btn btn-success">Edit</button>

    </form>
    </div>
);
}

    
     
    export default EditTodo;